var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamaskHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 356,
    height: 344,
    viewBox: "0 0 356 344",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.56,
    filter: "url(#filter0_f_54_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.031 98L187.6 144.369L199.145 117.012L250.031 98Z",
    fill: "#B100EA",
    stroke: "#B100EA",
    strokeWidth: 0.627451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.906 98L167.835 144.808L156.855 117.012L105.906 98ZM227.569 205.482L210.941 230.957L246.518 240.745L256.745 206.047L227.569 205.482ZM99.3177 206.047L109.482 240.745L145.059 230.957L128.431 205.482L99.3177 206.047Z",
    fill: "#B100EA",
    stroke: "#B100EA",
    strokeWidth: 0.627451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.051 162.439L133.137 177.435L168.463 179.004L167.208 141.043L143.051 162.439ZM212.886 162.439L188.416 140.604L187.6 179.004L222.863 177.435L212.886 162.439ZM145.059 230.957L166.267 220.604L147.945 206.298L145.059 230.957ZM189.671 220.604L210.941 230.957L207.992 206.298L189.671 220.604Z",
    fill: "#B100EA",
    stroke: "#B100EA",
    strokeWidth: 0.627451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.941 230.957L189.671 220.604L191.365 234.471L191.176 240.306L210.941 230.957ZM145.059 230.957L164.824 240.306L164.698 234.471L166.267 220.604L145.059 230.957Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.627451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.137 197.137L147.443 191.929L159.929 186.22L165.137 197.137ZM190.8 197.137L196.008 186.22L208.557 191.929L190.8 197.137Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.627451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.059 230.957L148.071 205.482L128.431 206.047L145.059 230.957ZM207.929 205.482L210.941 230.957L227.569 206.047L207.929 205.482ZM222.863 177.435L187.6 179.004L190.863 197.137L196.071 186.22L208.62 191.929L222.863 177.435ZM147.443 191.929L159.992 186.22L165.137 197.137L168.463 179.004L133.137 177.435L147.443 191.929Z",
    fill: "#9220B7",
    stroke: "#9220B7",
    strokeWidth: 0.627451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.137 177.435L147.945 206.298L147.443 191.929L133.137 177.435ZM208.62 191.929L207.992 206.298L222.863 177.435L208.62 191.929ZM168.463 179.004L165.137 197.137L169.278 218.533L170.22 190.361L168.463 179.004ZM187.6 179.004L185.906 190.298L186.659 218.533L190.863 197.137L187.6 179.004Z",
    fill: "#892AA7",
    stroke: "#892AA7",
    strokeWidth: 0.627451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.863 197.137L186.659 218.533L189.671 220.604L207.992 206.298L208.62 191.929L190.863 197.137ZM147.443 191.929L147.945 206.298L166.267 220.604L169.278 218.533L165.137 197.137L147.443 191.929Z",
    fill: "#9220B7",
    stroke: "#892AA7",
    strokeWidth: 0.627451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.176 240.306L191.365 234.471L189.796 233.09H166.141L164.698 234.471L164.824 240.306L145.059 230.957L151.961 236.604L165.953 246.329H189.984L204.039 236.604L210.941 230.957L191.176 240.306Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.627451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.671 220.604L186.659 218.533H169.279L166.267 220.604L164.698 234.471L166.141 233.09H189.796L191.365 234.471L189.671 220.604Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.627451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.667 147.38L258 121.78L250.031 98L189.671 142.8L212.886 162.439L245.702 172.039L252.98 163.569L249.843 161.31L254.863 156.729L250.973 153.718L255.992 149.89L252.667 147.38ZM98 121.78L103.333 147.38L99.9451 149.89L104.965 153.718L101.137 156.729L106.157 161.31L103.02 163.569L110.235 172.039L143.051 162.439L166.267 142.8L105.906 98L98 121.78Z",
    fill: "#5D1B73",
    stroke: "#5D1B73",
    strokeWidth: 0.627451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.702 172.039L212.886 162.439L222.863 177.435L207.992 206.298L227.569 206.047H256.745L245.702 172.039ZM143.051 162.439L110.235 172.039L99.3177 206.047H128.431L147.945 206.298L133.137 177.435L143.051 162.439ZM187.6 179.004L189.671 142.8L199.208 117.012H156.855L166.267 142.8L168.463 179.004L169.216 190.423L169.279 218.533H186.659L186.784 190.423L187.6 179.004Z",
    fill: "#892AA7",
    stroke: "#892AA7",
    strokeWidth: 0.627451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250.031 98L187.6 144.369L199.145 117.012L250.031 98Z",
    fill: "#B100EA",
    stroke: "#B100EA",
    strokeWidth: 0.627451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.906 98L167.835 144.808L156.855 117.012L105.906 98ZM227.569 205.482L210.941 230.957L246.518 240.745L256.745 206.047L227.569 205.482ZM99.3177 206.047L109.482 240.745L145.059 230.957L128.431 205.482L99.3177 206.047Z",
    fill: "#B100EA",
    stroke: "#B100EA",
    strokeWidth: 0.627451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143.051 162.439L133.137 177.435L168.463 179.004L167.208 141.043L143.051 162.439ZM212.886 162.439L188.416 140.604L187.6 179.004L222.863 177.435L212.886 162.439ZM145.059 230.957L166.267 220.604L147.945 206.298L145.059 230.957ZM189.671 220.604L210.941 230.957L207.992 206.298L189.671 220.604Z",
    fill: "#B100EA",
    stroke: "#B100EA",
    strokeWidth: 0.627451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M210.941 230.957L189.671 220.604L191.365 234.471L191.176 240.306L210.941 230.957ZM145.059 230.957L164.824 240.306L164.698 234.471L166.267 220.604L145.059 230.957Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.627451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M165.137 197.137L147.443 191.929L159.929 186.22L165.137 197.137ZM190.8 197.137L196.008 186.22L208.557 191.929L190.8 197.137Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.627451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.059 230.957L148.071 205.482L128.431 206.047L145.059 230.957ZM207.929 205.482L210.941 230.957L227.569 206.047L207.929 205.482ZM222.863 177.435L187.6 179.004L190.863 197.137L196.071 186.22L208.62 191.929L222.863 177.435ZM147.443 191.929L159.992 186.22L165.137 197.137L168.463 179.004L133.137 177.435L147.443 191.929Z",
    fill: "#9220B7",
    stroke: "#9220B7",
    strokeWidth: 0.627451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M133.137 177.435L147.945 206.298L147.443 191.929L133.137 177.435ZM208.62 191.929L207.992 206.298L222.863 177.435L208.62 191.929ZM168.463 179.004L165.137 197.137L169.278 218.533L170.22 190.361L168.463 179.004ZM187.6 179.004L185.906 190.298L186.659 218.533L190.863 197.137L187.6 179.004Z",
    fill: "#892AA7",
    stroke: "#892AA7",
    strokeWidth: 0.627451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M190.863 197.137L186.659 218.533L189.671 220.604L207.992 206.298L208.62 191.929L190.863 197.137ZM147.443 191.929L147.945 206.298L166.267 220.604L169.278 218.533L165.137 197.137L147.443 191.929Z",
    fill: "#9220B7",
    stroke: "#892AA7",
    strokeWidth: 0.627451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M191.176 240.306L191.365 234.471L189.796 233.09H166.141L164.698 234.471L164.824 240.306L145.059 230.957L151.961 236.604L165.953 246.329H189.984L204.039 236.604L210.941 230.957L191.176 240.306Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.627451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M189.671 220.604L186.659 218.533H169.279L166.267 220.604L164.698 234.471L166.141 233.09H189.796L191.365 234.471L189.671 220.604Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.627451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M252.667 147.38L258 121.78L250.031 98L189.671 142.8L212.886 162.439L245.702 172.039L252.98 163.569L249.843 161.31L254.863 156.729L250.973 153.718L255.992 149.89L252.667 147.38ZM98 121.78L103.333 147.38L99.9451 149.89L104.965 153.718L101.137 156.729L106.157 161.31L103.02 163.569L110.235 172.039L143.051 162.439L166.267 142.8L105.906 98L98 121.78Z",
    fill: "#5D1B73",
    stroke: "#5D1B73",
    strokeWidth: 0.627451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M245.702 172.039L212.886 162.439L222.863 177.435L207.992 206.298L227.569 206.047H256.745L245.702 172.039ZM143.051 162.439L110.235 172.039L99.3177 206.047H128.431L147.945 206.298L133.137 177.435L143.051 162.439ZM187.6 179.004L189.671 142.8L199.208 117.012H156.855L166.267 142.8L168.463 179.004L169.216 190.423L169.279 218.533H186.659L186.784 190.423L187.6 179.004Z",
    fill: "#892AA7",
    stroke: "#892AA7",
    strokeWidth: 0.627451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_54_32",
    x: 0.386276,
    y: 0.386215,
    width: 355.227,
    height: 343.557,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 48.65,
    result: "effect1_foregroundBlur_54_32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamaskHome);
export default __webpack_public_path__ + "static/media/metamaskHome.a42769d4f39b69ef50e629148c5c2c34.svg";
export { ForwardRef as ReactComponent };